import Table from "react-data-table-component";

const DataTableClient = ({ columns, data = [], loading = false, defaultSortField = null, defaultSortAsc = true, customStyles = {} }) => {
    return (
        <div id="user-list-table">
            <Table
                columns={columns}
                data={data}
                progressPending={loading}
                pagination
                sortIcon
                defaultSortField={defaultSortField}
                defaultSortAsc={defaultSortAsc}

                highlightOnHover
                striped
                persistTableHead

                progressComponent={
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "300px" }}
                    >
                        <div className="spinnerInner"></div>
                    </div>
                }

                customStyles={customStyles}
            />
        </div>
    );
};

export default DataTableClient;
